import { Hamburger } from "@/frontend/components/layout/navigation/hamburger";
import { Link } from "@/i18n/routing";
import clsx from "clsx";
import { Navigation } from "@/payload-types";
import { usePathname } from "@/i18n/routing";
import { useState } from "react";

const NavigationBlock = ({ docs } : { docs: Navigation }) => {
  const [isOpen, setIsOpen] = useState(false);
  const pathname = usePathname();

  return (
    <>
      <Hamburger isOpen={isOpen} setIsOpen={setIsOpen} />
      <nav>
        <ul>
          { docs.items ? docs.items.map((item, index) => {
              if (item && item?.page) {
                if (typeof item.page !== 'object') return null;
                if (!item.page?.slug) return null;
                const pageActive = pathname === `/${item.page.slug}`;

                const slug = item.page?.slug;

                return (
                  <li className={clsx('list-element-level-0')} key={index}>
                    <Link href={slug} className={clsx('navigation-menu-link-element', pageActive && 'active-page')}>
                      {item.label ? item.label : item?.page?.title}
                    </Link>
                  </li>
                );
              };
              return null;
            }): null}
        </ul>
      </nav>
    </>
  );
};
NavigationBlock.displayName = 'NavigationBlock';

export { NavigationBlock };